var React = require('react');

function ArizonaInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M21.9994 0V29.2526L18.7982 36.0826H16.1769L12.8189 31.8305L7.1549 30.5365L1.93487 33.1152L3.55557 55.229L7.15454 66.7435L5.19887 68.8308V78.0798L9.08833 82.3932L13.4634 91.0594L19.4412 98.0418L10.9203 104.092L7.13266 111.09L9.08833 117.997L7.13266 123.482L3.55593 128.551L2.91145 133.445L4.22265 141.238L9.08798 141.88L9.73102 147.722L7.1323 151.189L2.91109 151.829L0 156.829V160.471L110.688 200H168.436V0H21.9994Z","fill":"currentColor"}));
}

ArizonaInline.defaultProps = {"width":"169","height":"200","viewBox":"0 0 169 200","fill":"none"};

module.exports = ArizonaInline;

ArizonaInline.default = ArizonaInline;
